import {useSuspenseSafeHydrationDone} from '@aboutyou/lazy-imports';
import {useBasketToken} from '@aboutyou/user';
import {useEffect} from 'react';

/**
 * This component is just for e2e testing purposes. It basically tells the e2e if the page is ready to be interacted with.
 * This component is placed in parallel App->children in the tree, there for it will not cause any rerendering of the App.
 *
 * In react there is no way to know when all the Suspense boundaries are hydrated and are interactive.
 * The easiest way is to depend on the basketMinimal state, `waitForBasketTokenOnClientRequest` will become false when the basketMinimal state is done fetching.
 *
 * NOTE: This is just a way to make e2e testing easier, it should not be used for any other purpose.
 */
export const PageReadyHint = () => {
  const isHydrationDone = useSuspenseSafeHydrationDone();
  const {waitForBasketTokenOnClientRequest} = useBasketToken();

  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (isHydrationDone && !waitForBasketTokenOnClientRequest) {
      timeout = setTimeout(() => {
        // @ts-expect-error -- since this is an variable used only for e2e we don't need to define it in global types
        window.__PAGE_READY__ = true;
      }, 500); // giving a breathing room for the components to render once the basketSate is done fetching
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [isHydrationDone, waitForBasketTokenOnClientRequest]);

  return null;
};
